import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { ADD_IMAGES_SURVEYS, DELETE_IMAGES_SURVEYS } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { AddImagesSurveysDataActionTypes } from './types';
import api from 'src/utils/api';

export const loadAddImages =
  (
    td: any,
  ): ThunkAction<Promise<void>, State, null, AddImagesSurveysDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: ADD_IMAGES_SURVEYS + REQUEST });
    try {
      const payload = await api.loadAddImages(td);
      dispatch({ type: ADD_IMAGES_SURVEYS + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: ADD_IMAGES_SURVEYS + FAILURE, error });
    }
  };

export const addImagesIdle = () => ({ type: ADD_IMAGES_SURVEYS + IDLE });

export const addImageDelete = (id: number) => ({
  type: DELETE_IMAGES_SURVEYS,
  payload: id,
});
